import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AbDispositivoSip } from 'app/abstract/full-pages/voip/dispositivo-sip.abstract';
import { AppFilter } from 'app/models/app-filter.model';
import { Dispositivo } from 'app/models/dispositivo.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DispositivoSipService extends AbDispositivoSip {

  prefixo = "dispositivos/sip";

  constructor(http: HttpClient) {
    super(http);
  }

  public salvar(dispositivo: Dispositivo): Observable<any> {
    return this.save(`${this.prefixo}/create/`, dispositivo);
  }

  public getAllDispositivos(filter: AppFilter): Observable<any> {
    return this.get(`${this.prefixo}/ativos/${filter.encode()}`);
  }

  public desativar(id: number) {
    return this.delete(`${this.prefixo}/desativar/`, id);
  }

  public getById(id: number): Observable<any> {
    return this.get(`${this.prefixo}/findById/`, id);
  }

  public getConfigSIP(): Observable<any> {
    return this.get(`${this.prefixo}/config_sip`);
  }

  public getControleChamadaStatus(): Observable<{ controleChamadaAtivo: boolean }> {
    return this.get('api/v1/registro-chamadas/controle-chamada-status');
  }

  public getSipRegistrationStatus(): Observable<{ sipRegistrationStatusAtivo: boolean }> {
    return this.get('api/v1/registro-chamadas/sip-registration-status');
  }
}
